import { useSyncExternalStore } from 'react';

import {
  getAppliedTheme,
  getThemeChoice,
  setThemePreference,
  subscribeToTheme,
} from '@dashboard/lib/theme';

/**
 * `theme` is the device's Light / Dark / System (or Halloween) choice; `appliedTheme` is light or
 * dark as on screen right now, after System and the light-only sign-in and onboarding screens.
 */
export default function useTheme() {
  const theme = useSyncExternalStore(subscribeToTheme, getThemeChoice);
  const appliedTheme = useSyncExternalStore(subscribeToTheme, getAppliedTheme);
  return { theme, appliedTheme, setTheme: setThemePreference };
}
